import React from "react";
import { Typography, Button } from "@mui/material";
import "./Discover.scss";
import { Link } from "react-router-dom";

const Discover: React.FC = () => {
    return (
        <div className="discover-page">
            <div className="content">
                <img
                    src="https://www.digistakk.com/_next/static/media/carouselLady.42f30a32.svg"
                    alt="Discover"
                    className="illustration"
                />
                <Typography variant="h4" className="title">
                    Discover
                </Typography>
                <Typography variant="body1" className="subtitle">
                    Expand your professional network and build valuable relationships.
                </Typography>
            </div>
            <div className="footer">
                <Link to="/connect" className="skip-btn">
                    Skip
                </Link>
                <Button variant="contained" className="next-btn">
                    Next
                </Button>
            </div>
        </div>
    );
};

export default Discover;
